import { createContext, use } from "react";
import type { IPaginationContext } from "./types";

export const PaginationContext = createContext({} as IPaginationContext);

export const usePaginationContext = () => {
  return use(PaginationContext);
};
